import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Search from 'src/assets/images/Search.svg';
import Close from 'src/assets/images/CloseProduct.svg';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft.svg';
import {
    SearchResultsContainer,
    BackButtonContainer,
    BackButtonIcon,
    BackText,
    MessageContainer,
    TableContainer,
    BoldText,
    OrderCardsContainer,
    SearchHeader,
    DemiText,
    CloseIconContainer,
    CloseIcon,
    PaginationContainerMobile,
    SearchIcon,
    SearchIconContainer,
} from './SearchOrdersResult.styled';
import OrdersListTableView from 'src/pages/orders/components/ordersListTableView/OrdersListTableView';
import OrderCard from 'src/pages/orders/components/ordersListCardView/orderCard/OrderCard';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import { getDisplayDate } from 'src/utils/dateUtils';
import { MobileView, DesktopView } from 'src/pages/orders';
import {
    getSearchOrderListData,
    setOrdersLoading,
    toggleTableSearchLoader,
} from 'src/pages/orders/redux/actions';
import { useTranslation } from 'react-i18next';
import { isIpad } from 'src/utils/util';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { sizes } from 'src/styles/Media.styled';
// import FilterPopoverContainer from 'src/common/components/filter/FilterPopoverContainer';
import SearchOrdersPanel from 'src/pages/orders/components/searchOrdersPanel/SearchOrdersPanel';
import { isMobileView, logErrorToConsole } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SearchOrdersResult = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [pageControl, setPageControl] = useState(false);
    const [searchRecord, setSearchRecord] = useState(0);
    const [searchSortParam, setSearchSortParam] = useState('');
    const [searchSortOrder, setSearchSortOrder] = useState(-1);
    const [sortControl, setSortControl] = useState(false);
    const [dialogMargin, setDialogMargin] = useState('7rem');
    const [searchHeight, setSearchHeight] = useState('calc(100% - 7rem)');
    const [searchAnchorEl, setSearchAnchorEl] = useState(null);
    const searchIconEl = useRef(null);
    const searchPopoverId = searchAnchorEl
        ? 'simple-search-popover'
        : undefined;
    const [showSearch, setShowSearch] = useState(false);

    const {
        showSearchOrderResultsTable,
        searchOrderResultsClose,
        showOrdersResult,
        isOrderHistory = false,
        retriggerEventNotification,
        setRetriggerEventNotification,
        setNotificationDetails,
        notificationDetails,
        onAssignTerritory,
    } = props;

    const {
        searchResultOrderList,
        loading,
        totalSearcResults,
        sortOrder,
        sortParam,
        pageLimit,
        tableLoader,
    } = useSelector((state) => state.appliedOrdersSearchReducer);

    const { searchParams } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const displaySearchParams = { ...searchParams };
    const updateDate =
        displaySearchParams?.surgeryDate &&
        displaySearchParams.surgeryDate !== ''
            ? getDisplayDate(new Date(displaySearchParams.surgeryDate))
            : '';
    displaySearchParams.surgeryDate = updateDate;

    const searchParam = [Object.values(displaySearchParams)];
    const searchTerms = searchParam[0].filter((param) => param);

    useEffectWithErrorLogging(() => {
        if (totalSearcResults !== undefined) {
            setSearchRecord(totalSearcResults);
        }
    }, [totalSearcResults]);

    useEffectWithErrorLogging(() => {
        setSearchSortParam(sortParam);
        setSearchSortOrder(sortOrder === 'ASC' ? 1 : -1);
    }, [sortParam, sortOrder]);

    useEffectWithErrorLogging(() => {
        setPage(0);
        setFirst(0);
    }, []);

    useEffectWithErrorLogging(() => {
        if (sortControl) {
            searchHandler();
            setSortControl(false);
        }
    }, [searchSortParam, searchSortOrder]);

    useEffectWithErrorLogging(() => {
        if (pageControl) {
            searchHandler();
            setPageControl(false);
        }
    }, [page]);

    const onSearchSort = (event) => {
        setSearchSortParam(event.sortField);
        setSearchSortOrder(event.sortOrder);
        setSortControl(true);
    };

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
        setPageControl(true);
    };

    const searchHandler = () => {
        dispatch(
            getSearchOrderListData({
                searchParams: {
                    ...searchParams,
                },
                pageLimit: pageLimit,
                isActionItem: true,
                pageNo: page,
                sortOrder: searchSortOrder === 1 ? 'ASC' : 'DESC',
                sortParam: searchSortParam,
                  isFromOrderHistory:isOrderHistory,
            })
        );
    };
    const iPad = isIpad();

    const resetState = () => {
        setPage(0);
        setFirst(0);
        setPageControl(false);
        setSearchRecord(0);
        setSearchSortParam(sortParam);
        setSearchSortOrder(sortOrder === 'ASC' ? 1 : -1);
        setSortControl(false);
        setShowSearch(false);
    };

    const discardSearchModal = () => {
        resetState();
        searchOrderResultsClose();
    };

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    useEffectWithErrorLogging(() => {
        if (bannerHeight) {
            const bannerHeightValue = bannerHeight.slice(0, -2);
            const realBannerHeight = +bannerHeightValue - 120;
            const updatedBannerHeight = realBannerHeight + 'px';
            setDialogMargin(
                `calc(${
                    updatedBannerHeight ? updatedBannerHeight : '0px'
                } + 7rem)`
            );
            setSearchHeight(`calc(100% - ${updatedBannerHeight} - 7rem)`);
        } else {
            setDialogMargin('7rem');
            setSearchHeight('calc(100% - 7rem)');
        }
    }, [bannerHeight]);

    const searchContainerRef = useRef(null);
    const searchHeaderRef = useRef(null);
    const searchResultRef = useRef(null);

    window.onorientationchange = () => {
        if (iPad && showSearchOrderResultsTable && !showOrdersResult) {
            dispatch(setOrdersLoading(true));
            setTimeout(() => dispatch(setOrdersLoading(false)), 300);
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            window.innerWidth > sizes.mobileDevice &&
            showSearchOrderResultsTable &&
            !showOrdersResult
        ) {
            dispatch(toggleTableSearchLoader(false));
            setTimeout(() => dispatch(toggleTableSearchLoader(true)), 0);
        }
    }, [showSearchOrderResultsTable, showOrdersResult]);

    //SIM-853 - starts
    const openSearchPopOver = () => {
        setSearchAnchorEl(searchIconEl.current);
        setShowSearch((prevState) => !prevState);
    };

    const handleSearchClose = () => {
        setSearchAnchorEl(null);
        setShowSearch((prevState) => !prevState);
    };

    //SIM-853 - ends

    return (
        <>
            {showSearchOrderResultsTable &&
            !showOrdersResult &&
            searchTerms.length > 0 ? (
                <ModalDialog
                    modalHeight={
                        iPad ? 'calc(100vh - 120px)' : 'calc(100vh - 80px)'
                    }
                    modalWidth={'85%'}
                    smalModalWidth={'96%'}
                    left={iPad ? '1%' : '5%'}
                    right={iPad ? '1%' : '5%'}
                    marginTop={dialogMargin}
                    mobilePaperFullScreenHeight={searchHeight}
                    top={'5%'}
                    bottom={'5%'}
                    padding={'0.5rem 0 0 0'}
                    border={'none'}
                    margin={'0'}
                    handleClose={discardSearchModal}
                    zIndex={1000}
                    hideCloseIcon={isMobileView()}
                >
                    <SearchResultsContainer ref={searchContainerRef}>
                        <SearchHeader ref={searchHeaderRef}>
                            <BackButtonContainer
                            id="orders-searchordersresult-back-button-container"
                                onClick={discardSearchModal}
                                margin={'0'}
                                style={{ cursor: 'pointer' }}
                            >
                                <BackButtonIcon
                                    margin={'0 0 0 0px'}
                                    src={BackIcon}
                                />
                                <BackText mbDisplay={'none'}>
                                    {t('orders.reportsAndInvoice.sendUsageReport.backtorders')}
                                </BackText>
                            </BackButtonContainer>
                            <SearchIconContainer ref={searchIconEl}>
                                <SearchIcon
                                id="orders-searchordersresult-search-icon"
                                    aria-describedby={searchPopoverId}
                                    deskPath={Search}
                                    onClick={() => {
                                        try {
                                        openSearchPopOver();
                                        } catch (error) {
                                             logErrorToConsole(error);
                                         }
                                    }}
                                />
                            </SearchIconContainer>
                            <DemiText
                                fontSize="20px"
                                color="#140F4B"
                                mbWidth={'100%'}
                            >
                                {t('accounts.accountSearchResult.searchResults')}
                            </DemiText>
                            <CloseIconContainer>
                                {/* <CloseIcon
                                    mobilePath={Close}
                                    // onClick={() => setViewTemplate(false)}
                                    show={true}
                                    onClick={discardSearchModal}
                                /> */}
                            </CloseIconContainer>
                            {/* <FilterPopoverContainer
                                popoverId={searchPopoverId}
                                showPopOver={showSearch}
                                AnchorEl={searchAnchorEl}
                                handleClose={handleSearchClose}
                                top="130px"
                            > */}
                            {showSearch &&
                                window.innerWidth > sizes.mobileDevice && (
                                    <SearchOrdersPanel
                                     id="orders-searchordersresult-search-orders-panel"
                                        onClose={handleSearchClose}
                                        showSearch={showSearch}
                                        isOrderResultPopUp={true}
                                        isOrderHistory={isOrderHistory}
                                    />
                                )}
                            {/* </FilterPopoverContainer> */}
                        </SearchHeader>
                        {!loading ? (
                            <MessageContainer
                                ref={searchResultRef}
                                mbPadding={'0px 15px 5px 10px'}
                            >
                                {t('accounts.accountSearchResult.showing')}
                                <BoldText>
                                    {' '}
                                    {searchRecord !== '' ? searchRecord : 0}
                                </BoldText>{' '}
                                {searchRecord?.toString() === '1'
                                    ? t('orders.searchResultsPanel.resultLabel')
                                    : t('orders.searchResultsPanel.resultsLabel')}{' '}
                                {t('orders.searchResultsPanel.forLabel')}{' '}
                                {searchTerms?.map((searchTerm, index) => {
                                    return (
                                        <React.Fragment
                                            key={`${index} + ${searchTerm}`}
                                        >
                                            {'"'}
                                            <BoldText>{searchTerm}</BoldText>
                                            {'"'}
                                            {index < searchTerms.length - 1 && (
                                                <>{', '}</>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </MessageContainer>
                        ) : null}
                        {loading ? (
                            <Spinner
                                id="orders-searchOrdersResult-searchOrdersResult-loadingSpinner"
                                animation="border"
                                variant="primary"
                                small
                                height={'calc(100vh - 190px)'}
                            />
                        ) : searchResultOrderList?.length > 0 ? (
                            <>
                                <DesktopView>
                                    {tableLoader ? (
                                        <TableContainer>
                                            <OrdersListTableView
                                                scrollHeight={'250px'}
                                                isSearchOrderList
                                                searchOrderList={
                                                    searchResultOrderList
                                                }
                                                totalNumberOfRecords={
                                                    +searchRecord
                                                }
                                                isFromSearch={true}
                                                openOrderSummaryHandler={
                                                    props.openOrderSummaryHandler
                                                }
                                                searchOrderResultsClose={
                                                    searchOrderResultsClose
                                                }
                                                searchHandler={searchHandler}
                                                disablePaginator={false}
                                                searchPageNo={page}
                                                searchPageChangeHandler={
                                                    onPageChange
                                                }
                                                searchFirst={first}
                                                searchSortOrder={
                                                    searchSortOrder
                                                }
                                                searchSortParam={
                                                    searchSortParam
                                                }
                                                searchSortHandler={onSearchSort}
                                                searchRefHeight={
                                                    searchContainerRef &&
                                                    searchContainerRef?.current &&
                                                    searchContainerRef?.current
                                                        ?.clientHeight
                                                        ? searchContainerRef
                                                              .current
                                                              .clientHeight
                                                        : null
                                                }
                                                searchRefHeader={
                                                    searchHeaderRef &&
                                                    searchHeaderRef?.current &&
                                                    searchHeaderRef?.current
                                                        ?.clientHeight
                                                        ? searchHeaderRef
                                                              .current
                                                              .clientHeight
                                                        : null
                                                }
                                                searchRefResult={
                                                    searchResultRef &&
                                                    searchResultRef?.current &&
                                                    searchResultRef?.current
                                                        ?.clientHeight
                                                        ? searchResultRef
                                                              .current
                                                              .clientHeight
                                                        : null
                                                }
                                                parentRef={props.parentRef}
                                                retriggerEventNotification={retriggerEventNotification}
                                                setRetriggerEventNotification={setRetriggerEventNotification}
                                                setNotificationDetails={setNotificationDetails}
                                                notificationDetails={notificationDetails}
                                                isOrderHistory={isOrderHistory}
                                                onAssignTerritory={onAssignTerritory}
                                            />
                                        </TableContainer>
                                    ) : (
                                        <Spinner
                                            id="orders-searchOrdersResult-searchOrdersResult-tableLoadingSpinner"
                                            animation="border"
                                            variant="primary"
                                            small
                                            height={'calc(100vh - 190px)'}
                                        />
                                    )}
                                </DesktopView>
                                <MobileView
                                    flexGrow="1"
                                    overFlowY="scroll"
                                    overFlowX="hidden"
                                >
                                    <OrderCardsContainer>
                                        {searchResultOrderList?.map(
                                            (order, index) => {
                                                return (
                                                    <OrderCard
                                                        key={order.myCaseRef}
                                                        {...order}
                                                        isUsSurgeryNT={
                                                            order?.currentOrderType ==
                                                            'ZLC'
                                                                ? order?.isNonTissueExists
                                                                : false
                                                        }
                                                        isUsSurgeryT={
                                                            order?.currentOrderType ==
                                                            'ZLC'
                                                                ? order?.isTissueExists
                                                                : false
                                                        }
                                                        openOrderSummaryHandler={
                                                            props.openOrderSummaryHandler
                                                        }
                                                        isSearch={true}
                                                        mbMarginBottom={
                                                            searchResultOrderList.length -
                                                                1 ==
                                                                index && '270px'
                                                        }
                                                               
                                                                isHistory={isOrderHistory}
                                                    />
                                                );
                                            }
                                        )}
                                        <BottomNavigation
                                            padding={'0px'}
                                            mbPadding={'0px'}
                                            mbPosition={'fixed'}
                                            zIndex={2000}
                                        >
                                            <PaginationContainerMobile
                                                padding={'0px'}
                                            >
                                                <BasicPagination
                                                    totalRecords={+searchRecord}
                                                    recordsFetched={
                                                        searchResultOrderList?.length >
                                                        0
                                                            ? +searchResultOrderList.length
                                                            : 0
                                                    }
                                                    pageNumber={page}
                                                    handleChange={(e) =>
                                                        onPageChange(e)
                                                    }
                                                    first={first}
                                                    mobilePadding={
                                                        '2% 2% 2% 2%'
                                                    }
                                                    content={t('orders.searchOrdersPanel.ShowingOrders')}
                                                />
                                            </PaginationContainerMobile>
                                        </BottomNavigation>
                                    </OrderCardsContainer>
                                </MobileView>
                            </>
                        ) : (
                            <>
                                <MobileView>
                                    <div style={{ margin: '10px 11px' }}>
                                       {t('orders.searchOrdersPanel.MobileViewMsg')}
                                    </div>
                                </MobileView>
                                <DesktopView>
                                    <div style={{ margin: '10px 0' }}>
                                        {t('orders.searchOrdersPanel.DesktopViewMsg')}
                                    </div>
                                </DesktopView>
                            </>
                        )}
                    </SearchResultsContainer>
                </ModalDialog>
            ) : null}
        </>
    );
};

export default SearchOrdersResult;
